import api from './api';
import { Plan, PublicRide } from '../types';

export interface PublicRideFilters {
  search?: string;
  vehicleTypes?: string[];
  priorities?: string[];
  dutyTypes?: string[];
  pickupAreas?: string[];
  dropAreas?: string[];
  showSupply?: boolean;
  page?: number;
  limit?: number;
}

const csv = (values?: string[]) => (values && values.length ? values.join(',') : undefined);
const orJoin = (values?: string[]) => (values && values.length ? values.join('|') : undefined);

export const fetchPublicRides = async (filters?: string | PublicRideFilters) => {
  const params: Record<string, any> = {};
  if (typeof filters === 'string') {
    if (filters) params.search = filters;
  } else if (filters) {
    if (filters.search) params.search = filters.search;
    const v = csv(filters.vehicleTypes); if (v) params.vehicleTypes = v;
    const p = csv(filters.priorities); if (p) params.priorities = p;
    const d = csv(filters.dutyTypes); if (d) params.dutyTypes = d;
    const pu = orJoin(filters.pickupAreas); if (pu) params.pickupArea = pu;
    const dr = orJoin(filters.dropAreas); if (dr) params.dropArea = dr;
    if (filters.showSupply) params.showSupply = true;
    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;
  }
  const response = await api.get('/api/public/rides', {
    params: Object.keys(params).length > 0 ? params : undefined
  });
  const rides: PublicRide[] = response.data.rides.map((ride: any) => ({
    ...ride,
    id: ride.id || ride._id
  }));
  return {
    rides,
    freeRidesEnabled: response.data.freeRidesEnabled === true,
    pagination: response.data.pagination as { page: number; limit: number; total: number; pages: number }
  };
};

export const fetchPlans = async () => {
  const response = await api.get('/api/public/plans');
  const plans: Plan[] = response.data.plans.map((plan: any) => ({
    ...plan,
    id: plan._id
  }));
  return plans;
};

export interface TopUpPack {
  id: string;
  credits: number;
  price: number;
  currency: string;
  label: string;
  isActive?: boolean;
  popular?: boolean;
  sortOrder?: number;
}

export const fetchTopUpPacks = async (): Promise<TopUpPack[]> => {
  const response = await api.get('/api/public/top-up-packs');
  return response.data.packs || [];
};

export const fetchAppConfig = async (): Promise<{ freeRidesEnabled: boolean; signupFreeCredits: number }> => {
  const response = await api.get('/api/public/app-config');
  return response.data;
};

export interface ComparisonFeatureRow {
  _id: string;
  name: string;
  planIds: string[];
  sortOrder: number;
}

export const fetchComparisonFeatures = async (): Promise<ComparisonFeatureRow[]> => {
  const response = await api.get('/api/public/comparison-features');
  return response.data.features || [];
};

export interface DataDeletionRequestPayload {
  name: string;
  phoneNumber: string;
  email: string;
  reason: string;
  message: string;
}

export interface DataDeletionRequestResponse {
  message: string;
  requestId: string;
  status: 'pending' | 'reviewed' | 'completed' | 'rejected';
}

export const submitDataDeletionRequest = async (
  payload: DataDeletionRequestPayload
): Promise<DataDeletionRequestResponse> => {
  const response = await api.post('/api/public/data-deletion-requests', payload);
  return response.data;
};
